import { defineComponent as _defineComponent } from 'vue'
import { ref, getCurrentInstance } from 'vue';
import ButtonSwitch, { ButtonSwitchConfiguration } from '@/components/global/ButtonSwitch.vue';

interface Props {
    isCompany: any;
    name: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerTypeSection',
  props: {
    isCompany: null,
    name: null
  },
  emits: ["update:isCompany", "update:name"],
  setup(__props: any, { expose }: { emit: ({
    (e: 'update:isCompany', value: boolean): void;
    (e: 'update:name', value: string): void;
}), expose: any, slots: any, attrs: any }) {





// Template ref for name input
const nameInput = ref<HTMLElement | null>(null);

// Expose refs for parent component access
expose({
    nameInput,
});

const proxy = getCurrentInstance()?.proxy as any;

const customerTypeSwitch: ButtonSwitchConfiguration = {
    firstOptionLabel: 'Natural person',
    firstOptionValue: false,
    secondOptionLabel: 'Company',
    secondOptionValue: true,
};

return { __sfc: true,nameInput, proxy, customerTypeSwitch, ButtonSwitch }
}

})